import React from "react";

export const FullpageHeader = ({ children }) => {
  return <header className="text-center pt-4">{children}</header>;
};

export const FullPageText = ({ children }) => {
  return <p className="mb-4 text-lg">{children}</p>;
};

export const FullPageSection = ({ children }) => {
  return (
    <section className="full-panel grid place-content-center">
      {children}
    </section>
  );
};
export const FullPageOverlay = ({ children }) => {
  return <div className="bg-white p-4 shadow-md w-96">{children}</div>;
};

export const FullPageOverlayWide = ({ children }) => {
  return (
    <div className="bg-white px-4 py-0 shadow-md w-[40rem]">{children}</div>
  );
};
